import React from 'react';
import {PageCover, Footer, Contact, CustomerInfo, FAQ} from 'components/section';

const Customer = () => {
 return (
  <div className="Customer padding-cover">
    <PageCover 
      url="customer"
      title = "CUSTOMER CENTER" 
      text = "동구밭을 사랑해주는 분들과 함께 만들어 가기 위해 목소리에 귀를 기울입니다"
    />

    <CustomerInfo className = "bgColor-lightGrey"/>
    <FAQ />

    <Contact className = "bgColor-lightGrey"/>
    <Footer />
  </div>
 );
}

export default Customer;